import { render, staticRenderFns } from "./AnnouncementView.vue?vue&type=template&id=6a6cf605&scoped=true&"
import script from "./AnnouncementView.vue?vue&type=script&lang=js&"
export * from "./AnnouncementView.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementView.vue?vue&type=style&index=0&id=6a6cf605&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6cf605",
  null
  
)

export default component.exports